import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import MobileCard from './MobileCard';
import { formatDate } from '../utils/dateUtils';
import { getZoneApi } from '../api';
import './MobileMatchList.css';

/**
 * 移动端友好的比赛列表组件
 * 
 * @returns {JSX.Element} 移动端比赛列表组件
 */
const MobileMatchList = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { zone = 'zone1' } = useParams(); // 获取当前区域参数
  
  // 检查是否在移动端专用路径下（未使用，已注释）
  // const isMobileRoute = location.pathname.startsWith('/mobile');

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        setLoading(true);
        const zoneApi = getZoneApi(zone); // 获取当前区域的API客户端
        const response = await zoneApi.matches.getAll();
        setMatches(response.data || []);
        setLoading(false);
      } catch (err) {
        setError('获取比赛数据失败');
        setLoading(false);
        console.error(`获取区域 ${zone} 的比赛数据失败:`, err);
      }
    };

    fetchMatches();
  }, [zone]); // 当区域变化时重新获取数据

  const handleMatchClick = (matchId) => {
    // 根据当前路径决定导航目标
    navigate(`/${zone}/matches/${matchId}`);
  };

  // 获取比赛类型的中文显示
  const getMatchTypeDisplay = (type) => {
    return type === '单打' ? '单打' : '双打';
  };

  // 获取比赛结果的简短显示
  const getScoreDisplay = (scores) => {
    if (!scores || scores.length === 0) return '';
    
    return scores.map((score, index) => (
      `${score.team1Score}-${score.team2Score}${index < scores.length - 1 ? ', ' : ''}`
    )).join('');
  };

  // 获取参与者名称的显示
  const getPlayersDisplay = (players) => {
    if (!players) return '';
    
    const team1Names = players.team1.map(player => player.name || '未知').join(', ');
    const team2Names = players.team2.map(player => player.name || '未知').join(', ');
    
    return `${team1Names} vs ${team2Names}`;
  };

  if (loading) {
    return <div className="mobile-loading">加载中...</div>;
  }

  if (error) {
    return <div className="mobile-error">{error}</div>;
  }

  return (
    <div className="mobile-match-list">
      <h1>比赛列表 - {zone === 'zone1' ? '区域1' : '区域2'}</h1>
      {matches.length === 0 ? (
        <div className="mobile-no-data">暂无比赛数据</div>
      ) : (
        matches.map((match) => (
          <MobileCard
            key={match._id}
            title={`${getMatchTypeDisplay(match.type)} - ${formatDate(match.date)}`}
            extra={match.winner === 'team1' ? '主队胜' : '客队胜'}
            onClick={() => handleMatchClick(match._id)}
            className="mobile-match-card"
          >
            <div className="mobile-match-players">
              {getPlayersDisplay(match.players)}
            </div>
            <div className="mobile-match-score">
              比分: {getScoreDisplay(match.scores)}
            </div>
            <div className="mobile-match-location">
              场地: {match.location || '未知'}
            </div>
          </MobileCard>
        ))
      )}
    </div>
  );
};

export default MobileMatchList; 